export enum Shade {
  DARK = 'DARK',
  MEDIUM = 'MEDIUM',
  LIGHT = 'LIGHT',
  WARNING = 'WARNING',
}
